import {
  ApiService,
  AuthService,
  DocumentService,
  EmployeeService as NewEmployeeService,
  SummaryService,
  ReportingService,
  EightThreeFourService,
  PlanService
} from 'react-angle-dashboard-components'
import { BillingService } from './billing'
import { BrokerService } from './broker'
import { GroupService } from './group/group'
import { QuoteService } from './quote/quote'
import { TempAuthService } from './temp-auth'

const BASE_URL = (window as any).runtimeConfig?.apiURL
const appName = "brokerportal"

export const authService = new AuthService(`${BASE_URL}/${appName}`)
export const brokerService = new BrokerService(`${BASE_URL}/${appName}`)
export const groupService = new GroupService(`${BASE_URL}/${appName}`)
export const documentService = new DocumentService(`${BASE_URL}/${appName}`)
export const newEmployeeService = new NewEmployeeService(`${BASE_URL}/${appName}`)
export const eightThreeFourService = new EightThreeFourService(`${BASE_URL}/${appName}`)
export const billingService = new BillingService(`${BASE_URL}/${appName}`)
export const summaryService = new SummaryService(`${BASE_URL}/${appName}`)
export const plansService = new PlanService(`${BASE_URL}/${appName}`)
export const quoteService = new QuoteService(`${BASE_URL}/${appName}`)
export const reportingService = new ReportingService(`${BASE_URL}/${appName}`)
export const tempAuthService = new TempAuthService(`${BASE_URL}/${appName}`)

export { ApiService }
